
import Vue from 'vue'
import Icon from '../../icon.vue'
import Placeholder from './placeholder.vue'
import VLabel from './label.vue'
import Type from './type.vue'
export default Vue.extend({
  components: {
    VLabel,
    Placeholder,
    Type,
    Icon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'text'
    },
    inputFontStyle: {
      type: String,
      default: 'default'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocus: false
    }
  },
  computed: {
    proxyValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    /**
     * 类型有两种
     * 1. placeholder 虚拟提示
     * 2. label dom 真是元素提示
     * 默认类型为1，label类型权重更高，有label忽略 placeholder；
     * label时 icon为进入下一页的icon，placeholder时input输入显示clear icon
     */
    componentType(): number {
      return this.label ? 2 : 1
    },
    isLabel(): boolean {
      return this.componentType === 2
    }
  },
  methods: {
    focus(e) {
      this.isFocus = true
      this.$emit('focus', e)
    },
    blur(e) {
      this.isFocus = false
      this.$emit('blur', e)
    },
    clearValue() {
      this.proxyValue = ''
    }
  },
  render() {
    return (
      <div class="du-input-wrap">
        {this.componentType === 1 ? (
          <placeholder
            class="placeholder"
            placeholder={this.placeholder}
            value={this.value}
            is-focus={this.isFocus}
          />
        ) : (
          <v-label class="label" label={this.label} />
        )}
        <div
          class={[
            'input-group',
            this.inputFontStyle,
            this.isLabel && 'is-label'
          ]}
        >
          <type
            {...{ attrs: { ...this.$attrs } }}
            {...{ on: { ...this.$listeners } }}
            type={this.type}
            component-type={this.componentType}
            on-focus={this.focus}
            v-model={this.proxyValue}
            on-blur={this.blur}
            readonly={this.readonly}
          />
          {this.$slots.icons ? (
            this.$slots.icons
          ) : this.componentType === 1 ? (
            this.value !== '' ? (
              <icon
                icon="icon-close_filledx"
                nativeOn-click={this.clearValue}
              />
            ) : (
              ''
            )
          ) : (
            <icon icon={'icon-enter'} color="#000" />
          )}
        </div>
      </div>
    )
  }
})
